<template>
    <tag-box :tags="tags" :font-size="fontSize" @handleTag="handleTag"/>
</template>

<script>
export default {
    name: "index",
    props: {
        tags: {
            type: Array,
            default() {
                return []
            }
        },
        fontSize: {
            type: String,
            default() {
                return '14px'
            }
        }
    },
    inject: ['openSearch'],
    methods: {
        handleTag(tag) {
            this.openSearch(tag)
        }
    }
}
</script>

<style scoped>

</style>
